// extracted by mini-css-extract-plugin
module.exports = {"Coconut":"#F4F7FA","FontStyleBody":"15px/24px AxiformaBook,Helvetica,sans-serif"};